import avatar from './anyone.png';

export const ANYONE_ID = '0';

export const ANYONE = {
  avatar,
  extraData: null,
  id: ANYONE_ID,
  name: 'Anyone',
};